import { render, staticRenderFns } from "./textareaModule.vue?vue&type=template&id=f18e7be8&lang=html"
import script from "./textareaModule.vue?vue&type=script&lang=js"
export * from "./textareaModule.vue?vue&type=script&lang=js"
import style0 from "./textareaModule.vue?vue&type=style&index=0&id=f18e7be8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f18e7be8')) {
      api.createRecord('f18e7be8', component.options)
    } else {
      api.reload('f18e7be8', component.options)
    }
    module.hot.accept("./textareaModule.vue?vue&type=template&id=f18e7be8&lang=html", function () {
      api.rerender('f18e7be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueQuillEditorMerchandise/div/textareaModule.vue"
export default component.exports